
const AnchorFilter=($state)=>{

    return (id)=>{
        return '/#' + $state.current.url + '#' + id;
    };
};


AnchorFilter.$inject = ['$state'];

export default AnchorFilter;


// WEBPACK FOOTER //
// ./src/busqueda/filtros/anchor.filter.js